import {Directive, ElementRef, HostListener} from '@angular/core';

@Directive({
  selector: '[appEmailMask]'
})
export class EmailMaskDirective {
  private readonly allowedChars = /^[\w.-_+@]*$/;

  constructor(private el: ElementRef) {}

  @HostListener('keydown', ['$event'])
  @HostListener('input', ['$event'])
  onInput(event: KeyboardEvent | InputEvent): void {
    const input = this.el.nativeElement as HTMLInputElement;
    const cursorPos = input.selectionStart || input.value.length;  // Fallback to end

    if ('key' in event) {
      const char = (event as KeyboardEvent).key;
      if (!this.allowedChars.test(char) && char.length === 1) {
        event.preventDefault();
        return;
      }
    }

    const oldType = input.type;
    input.type = 'text';
    input.value = input.value.replace(/[^\w.-_+@]/g, '');
    input.setSelectionRange(cursorPos, cursorPos);
    input.type = oldType;
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    event.preventDefault();
    const paste = event.clipboardData?.getData('text') || '';
    const cleanPaste = paste.replace(/[^\w.-_+@]/g, '');
    const input = this.el.nativeElement as HTMLInputElement;
    input.value = cleanPaste;

    input.dispatchEvent(new Event('input', { bubbles: true }));
  }
}
